export enum LocaleCodes {
  en = "en",
  ja = "ja",
  ko = "ko",
  fr = "fr",
  es = "es",
  pt = "pt",
}
